import { render, staticRenderFns } from "./TenantNextReviewerModal.vue?vue&type=template&id=797bad39&scoped=true&"
import script from "./TenantNextReviewerModal.vue?vue&type=script&lang=js&"
export * from "./TenantNextReviewerModal.vue?vue&type=script&lang=js&"
import style0 from "./TenantNextReviewerModal.vue?vue&type=style&index=0&id=797bad39&scoped=true&lang=scss&"
import style1 from "./TenantNextReviewerModal.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "797bad39",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('797bad39')) {
      api.createRecord('797bad39', component.options)
    } else {
      api.reload('797bad39', component.options)
    }
    module.hot.accept("./TenantNextReviewerModal.vue?vue&type=template&id=797bad39&scoped=true&", function () {
      api.rerender('797bad39', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/tenantProjects/submissions/TenantNextReviewerModal.vue"
export default component.exports